export default __webpack_public_path__ + "static/media/account-bg.5175821d.jpg";